module.exports = __webpack_public_path__ + "static/media/apple.ab556aeb.svg";